<template>
	<div>
		<chart :chart-data="Data" @sendChart="chartApi = $event" :options="Options"></chart>
		<div v-if="chartApi != null">
			<chart-legend class="chart-legend" :chart.sync="Data" :ChartApi="chartApi" @updateChartData="updateChart"></chart-legend>
		</div>
	</div>
</template>

<script>
	import Pie from "@/components/chart/pie.vue";
	import Legend from "@/components/chart/metaDataLegend.vue";
	export default {
		name: 'Pie-Chart',
		components: {
			'chart': Pie,
			'chart-legend': Legend
		},
		props: {
			Data: Object,
			Options: Object,
		},
		data() {
			return {
				chartApi: null
			}
		},
		created() {
		},
		methods: {
			updateChart(i) {
				//console.log(i)

			}
		}
	}
</script>
